import fs from "fs"
import path from "path"
import React from "react"
import Sticky from "react-stickynode"
import styled from "styled-components"
import { themeGet } from "@styled-system/theme-get"
import { useTranslation } from "next-i18next"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import ResetCSS from "@/common/assets/css/style"
import NavbarNew from "@/containers/common/NavbarNew"
import Footer from "@/containers/common/FooterNew"
import SectionLine from "@/common/components/SectionLine"
import MetaData from "@/common/components/MetaData"
import Container from "@/common/components/UI/Container"
import { AppWrapper, ContentWrapper } from "@/containers/common/style"
import ReactMarkdown from "react-markdown"

const TermsOfUseIndividual = ({ content }: { content: any }) => {
  const { t } = useTranslation("termsOfUse")

  return (
    <div>
      <>
        <MetaData
          title={t("meta.title")}
          description={t("meta.description")}
          url={t("meta.url")}
          image="https://storage.googleapis.com/kryptogo-official-website-public/og-logo.webp"
          languageAlternates={[
            {
              hrefLang: "en-US",
              href: "https://www.kryptogo.com/terms-of-service/individual"
            },
            {
              hrefLang: "zh-TW",
              href: "https://www.kryptogo.com/tw/terms-of-service/individual"
            },
            {
              hrefLang: "zh-CN",
              href: "https://www.kryptogo.com/cn/terms-of-service/individual"
            },
            {
              hrefLang: "ja-JP",
              href: "https://www.kryptogo.com/ja/terms-of-service/individual"
            }
          ]}
        />
        <ResetCSS />
        <AppWrapper>
          <Sticky top={0} innerZ={1000} activeClass="sticky-active">
            <NavbarNew />
          </Sticky>
          <Container>
            <ContentWrapper>
              <Wrapper>
                <ReactMarkdown>{content}</ReactMarkdown>
              </Wrapper>
            </ContentWrapper>

            <SectionLine />
          </Container>
          <Footer />
        </AppWrapper>
      </>
    </div>
  )
}

export const getStaticProps = async ({ locale }: { locale: string }) => {
  const localeFile = locale === "tw" ? "tw" : "en"
  // Path to the markdown file
  const filePath = path.join(
    process.cwd(),
    "public",
    `terms-of-service/individual/${localeFile}.md`
  )
  // Read the file content
  const content = fs.readFileSync(filePath, "utf8")

  return {
    props: {
      ...(await serverSideTranslations(locale, [
        "termsOfUse",
        "common",
        "contactUs"
      ])),
      content
    }
  }
}

export default TermsOfUseIndividual

const Wrapper = styled.div`
  max-width: 1024px;
  margin-bottom: 200px;
  margin-left: auto;
  margin-right: auto;
  @media (max-width: 768px) {
    margin-bottom: 80px;
  }
  a {
    color: ${themeGet("colors.primary")};
  }
  h1 {
    font-size: var(--h1);
    background: linear-gradient(130deg, #ffffff, #ffc211) text;
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    text-align: center;
    padding-top: 160px;
    text-shadow:
      0 0 10px rgba(255, 194, 17, 0.2),
      0 0 30px rgba(255, 194, 17, 0.5);
    @media (max-width: 768px) {
      padding-top: 100px;
    }
    @media (max-width: 1024px) {
      font-size: var(--h2);
    }
  }
  h2 {
    font-size: 2rem;
    font-weight: 700;
    margin-top: 2.5rem;
    margin-bottom: 2rem;
    color: ${themeGet("colors.primary")};
  }
  h3 {
    margin-top: 2rem;
    margin-bottom: 1.75rem;
  }
  h4 {
    margin-top: 2rem;
    margin-bottom: 1rem;
  }
  p {
    margin-bottom: 10px;
  }
  ul {
    margin-bottom: 4px;
    list-style-type: none;
    counter-reset: list-counter;
    li {
      margin-left: 20px;
      margin-bottom: 20px;
      counter-increment: list-counter;
    }
    li::before {
      content: "(" counter(list-counter, lower-alpha) ") ";
    }
  }

  ol {
    list-style-type: decimal;
    li {
      margin-left: 20px;
      list-style-type: decimal;
      margin-bottom: 20px;
      div {
        margin-top: 10px;
        margin-bottom: 10px;
      }
    }
  }
  @media (max-width: 768px) {
    ul,
    ol {
      li {
        margin-left: 0px;
      }
    }
  }
`
